import { render } from "./Workspace.vue?vue&type=template&id=0938b1eb&scoped=true"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=0938b1eb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0938b1eb"

export default script